import { Toaster as Sonner } from "sonner";

function Toaster() {
	return (
		<Sonner
			theme="dark"
			position="bottom-right"
			toastOptions={{
				classNames: {
					toast:
						"group border-divider bg-bg-secondary text-text-default shadow-lg rounded-xl font-inter",
					title: "text-sm font-medium",
					description: "text-xs text-text-secondary",
					actionButton: "bg-brand text-white text-xs font-medium",
					cancelButton: "bg-bg-tertiary text-text-secondary text-xs font-medium",
					error:
						"border-destructive/30 bg-destructive/10 text-destructive",
					success:
						"border-success/30 bg-success/10 text-success",
				},
			}}
		/>
	);
}

export { Toaster };
